import { render, staticRenderFns } from "./nodeal.vue?vue&type=template&id=0228dd89&scoped=true&"
import script from "./nodeal.vue?vue&type=script&lang=js&"
export * from "./nodeal.vue?vue&type=script&lang=js&"
import style0 from "./nodeal.vue?vue&type=style&index=0&id=0228dd89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0228dd89",
  null
  
)

export default component.exports